/**
 * @desc 供需审核
 */
import { SupplyDemandAuditForm } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type AuditSupplyDemandParameter = SupplyDemandAuditForm

const method = 'PUT'
const url = '/trade/operation/supplyDemand/auditSupplyDemand'

export const auditSupplyDemandApi = (
  data?: AuditSupplyDemandParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    data,
    ...config
  })
}

auditSupplyDemandApi.method = method
auditSupplyDemandApi.url = url
